import { DefaultConfigProps, MenuOrientation, ThemeDirection, ThemeMode } from 'types/config';
import packageJson from '../package.json';

export const twitterColor = '#1DA1F2';
export const facebookColor = '#3b5998';
export const linkedInColor = '#0e76a8';

export const APP_DEFAULT_PATH = '/welcome-page';
export const HORIZONTAL_MAX_ITEM = 6;
export const DRAWER_WIDTH = 260;

const config: DefaultConfigProps = {
    fontFamily: `'Public Sans', sans-serif`,
    i18n: 'en',
    menuOrientation: MenuOrientation.VERTICAL,
    miniDrawer: false,
    container: true,
    firstBuilderStart: false,
    builderProject: null,
    mode: ThemeMode.LIGHT,
    presetColor: 'default',
    showBuilderGuide: false,
    themeDirection: ThemeDirection.LTR,
};

export const APP_NAME = packageJson.name;
export const APP_VERSION = packageJson.version;

export default config;
